import React, { useEffect, useRef } from 'react';
import './HeroSection.css';

const ParticleLights = () => {

    return (
        <div>
            <div className='particle-light light-1'></div>
            <div className='particle-light light-2'></div>
            <div className='particle-light light-3'></div>
            <div className='particle-light light-4'></div>
            <div className='particle-light light-5'></div>
            <div className='particle-light light-6'></div>
            <div className='particle-light light-7'></div>
            <div className='particle-light light-8'></div>
            <div className='particle-light light-9'></div>
            <div className='particle-light light-10'></div>
        </div>
    );
};

export default ParticleLights;
